import { useEffect, useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import routes from '../../Routes';
import { getAccessToken } from '../auth';
import { useEvent } from './hooks/useEvent';

export function ViewEventListener() {
  const accessToken = getAccessToken();

  const allRoutes = useMemo(() => routes.filter((r) => !!r.event).map((r) => ({ event: r.event, path: r.path })));

  const location = useLocation();
  const { track } = useEvent();

  useEffect(() => {
    const route = allRoutes.find((route) => {
      if (route.path.includes('/*')) {
        return route.path.split('/*')[0] === location.pathname;
      }
      return location.pathname === route.path;
    });
    if (route && accessToken) {
      track(route.event);
    }
  }, [accessToken, location.pathname]);

  return '';
}
